/**
 * Page Nos Valeurs - FTPE Outremer
 */
import React from 'react';
import { Heart, Scale, Users, Leaf, Shield, Globe, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useNavigate } from 'react-router-dom';
import BackButton from '../components/BackButton';

// Logo FTPE Outremer
const FTPE_LOGO = "https://customer-assets.emergentagent.com/job_80d9c916-7281-4428-9c84-a6e0cd256c92/artifacts/ojac2aim_logo%20ftpe%20outremer%20dans%20fond%20blanc.png";

export default function FTPEValeursPage() {
  const navigate = useNavigate();

  const valeurs = [
    {
      icon: Scale,
      title: "Indépendance",
      description: "Liberté de parole et d'action, sans affiliation partisane ni dépendance à l'égard de groupes d'intérêts extérieurs."
    },
    {
      icon: Heart,
      title: "Équité",
      description: "Égalité de traitement entre adhérents, respect des diversités territoriales et sectorielles."
    },
    {
      icon: Users,
      title: "Solidarité ultramarine",
      description: "Entraide entre TPE ultramarines, mutualisation des ressources et des bonnes pratiques."
    },
    {
      icon: Shield,
      title: "Responsabilité",
      description: "Transparence dans la gouvernance, rigueur dans la gestion et éthique dans les partenariats."
    },
    {
      icon: Leaf,
      title: "Développement durable",
      description: "Promotion d'une économie respectueuse des territoires, des hommes et de l'environnement."
    }
  ];

  return (
    <div className="min-h-screen bg-slate-50">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-slate-900 via-green-900 to-slate-900 text-white py-20 px-6">
        <div className="max-w-5xl mx-auto">
          <div className="mb-6">
            <BackButton variant="dark" label="Retour" />
          </div>
          
          <div className="flex items-center gap-6 mb-8">
            <img src={FTPE_LOGO} alt="FTPE Outremer" className="w-20 h-20 object-contain rounded-lg bg-white p-2" />
            <div>
              <h1 className="text-4xl md:text-5xl font-bold mb-2">
                Nos <span className="text-amber-400">valeurs</span>
              </h1>
              <p className="text-xl text-slate-300">Les principes qui guident notre action</p>
            </div>
          </div>
        </div>
      </section>

      {/* Content */}
      <div className="max-w-5xl mx-auto bg-white shadow-lg -mt-10 relative z-10 rounded-2xl p-8 md:p-12 mb-12">
        
        {/* Introduction */}
        <section className="mb-12">
          <p className="text-lg text-slate-700 leading-relaxed">
            La FTPE Outremer fonde son action sur des valeurs fortes, partagées par l'ensemble
            de ses adhérents et de ses instances. Ces principes guident nos décisions,
            nos partenariats et notre engagement au quotidien.
          </p>
        </section>

        {/* Valeurs */}
        <section className="mb-12">
          <div className="space-y-6">
            {valeurs.map((valeur, index) => (
              <div key={index} className="flex items-start gap-6 p-6 bg-gradient-to-r from-slate-50 to-green-50 rounded-xl border-l-4 border-amber-500">
                <div className="p-4 bg-green-100 rounded-xl flex-shrink-0">
                  <valeur.icon className="w-8 h-8 text-green-700" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-slate-900 mb-2">{valeur.title}</h3>
                  <p className="text-slate-600 leading-relaxed">{valeur.description}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Citation */}
        <section className="mb-12">
          <div className="bg-gradient-to-r from-green-700 to-emerald-700 text-white p-8 rounded-2xl text-center">
            <Globe className="w-12 h-12 mx-auto mb-4 text-amber-400" />
            <p className="text-xl italic leading-relaxed">
              « Nos valeurs sont le socle de notre légitimité et la garantie de notre crédibilité
              auprès de nos adhérents, de nos partenaires et des pouvoirs publics. »
            </p>
          </div>
        </section>

        {/* CTA */}
        <div className="text-center">
          <Button 
            onClick={() => navigate('/adhesion-ftpe-workflow')}
            className="bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white px-8 py-4 text-lg rounded-xl"
          >
            Rejoindre la FTPE Outremer
            <ArrowRight className="ml-2 w-5 h-5" />
          </Button>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-slate-900 text-white py-8 text-center">
        <p className="font-semibold">FTPE Outremer – Syndicat patronal ultramarin</p>
        <p className="text-slate-400 text-sm mt-2">Indépendance • Équité • Responsabilité</p>
      </footer>
    </div>
  );
}
